import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { getUserId } from "@/api/localStorage";
import { checkReferralEligibility } from "@/api/referral";
import useUserEmail from "@/shared/hooks/useUserEmail";
import "./ReferralWidget.scss";
import referralWidgetIcon from "@/shared/assets/img_used/referral-widget.svg";
import referralWidgetIconClose from "@/shared/assets/img_used/closeLargeCircle.svg";
import { Portal } from "@/shared/components";
import { useIsMobile } from "@/cms/useIsMobile";
import { isAllowedRAFRoute } from "@/shared/utils/utils";
import Icon from "@/shared/components/Icon/Icon";

const ReferralWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const location = useLocation();
  const userId = getUserId();
  const isMobile = useIsMobile();
  const userEmail = useUserEmail();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const { data: eligibilityData, isLoading } = useQuery(
    ["referral-eligibility", userId],
    () => checkReferralEligibility(userId),
    {
      enabled: !!userId,
    }
  );

  const isAllowedRoute = isAllowedRAFRoute(location.pathname);

  if (isMobile || isLoading || !eligibilityData?.showRef || !isAllowedRoute || !isReady) return null;

  return (
    <>
      <Portal id="mainLayout">
        {isOpen ? (
          <div className="referral-widget__button closeButton" onClick={() => setIsOpen(false)}>
            <img
              className="referral-widget__button-img-close"
              src={referralWidgetIconClose}
              alt="Referral Widget"
              width={"24px"}
              height={"24px"}
            />
          </div>
        ) : (
          <div className="referral-widget__button openButton" onClick={() => setIsOpen(true)}>
            <img
              className="referral-widget__button-img-open"
              src={referralWidgetIcon}
              alt="Referral Widget open"
              width={"30px"}
              height={"28.16px"}
            />
          </div>
        )}
      </Portal>

      {isOpen && (
        <Portal>
          <div className="referral-widget__overlay" onClick={() => setIsOpen(false)} />{" "}
          <div className="referral-widget__modal">
            <div className="referral-widget__modal-title">
              Freunde werben und je 25 € BestChoice-Premium-Gutschein sichern
            </div>
            <div className="referral-widget__modal-text">
              <span className="referral-widget__modal-text--normal">
                Empfehlen Sie unseren kostenlosen Wechselservice an Ihre Freunde und Familie weiter – und sichern Sie
                sich und Ihren Liebsten
              </span>
              <span className="referral-widget__modal-text--bold">
                {" "}
                jeweils einen 25 € BestChoice-Premium-Gutschein{" "}
              </span>
              <span className="referral-widget__modal-text--normal">als Dankeschön!</span>
            </div>
            <div
              className="referral-widget__modal-button"
              onClick={() =>
                (window.location.href = `/mein-remindme/freunde-werben-freunde?email=${userEmail}&autoDetect=1`)
              }
            >
              <div className="referral-widget__modal-button-text">Jetzt Freunde werben</div>
              <Icon className="arrow" name={"arrowRight"} />
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default ReferralWidget;
